import { Directive, EventEmitter, HostListener, Output } from '@angular/core';

@Directive({
  selector: '[tdWbSwipe]',
  exportAs: 'tdWbSwipe'
})
export class SideSheetSwipeDirective {

  @Output() next: EventEmitter<void> = new EventEmitter<void>();
  @Output() previous: EventEmitter<void> = new EventEmitter<void>();
  @Output() up: EventEmitter<void> = new EventEmitter<void>();
  @Output() down: EventEmitter<void> = new EventEmitter<void>();
  swipeCoordinates: Array<number> = [0, 0];
  swipeTime: number = new Date().getTime();

  @HostListener('touchstart', ['$event']) onSwipeStart($event: TouchEvent): void {
    this.onSwipe($event, 'start');
  }

  @HostListener('touchend', ['$event']) onSwipeEnd($event: TouchEvent): void {
    this.onSwipe($event, 'end');
  }

  onSwipe(e: TouchEvent, when: string): void {
    this.swipe(e, when);
  }

  swipe(e: TouchEvent, when: string): void {

    const coordinates: [number, number] = [e.changedTouches[0].clientX, e.changedTouches[0].clientY];
    const time = new Date().getTime();

    if (when === 'start') {
      this.swipeCoordinates = coordinates;
      this.swipeTime = time;
    } else if (when === 'end') {
      const direction = [coordinates[0] - this.swipeCoordinates[0], coordinates[1] - this.swipeCoordinates[1]];
      const duration = time - this.swipeTime;
      const fastEnough = duration < 1000;
      const longHorizontalEnough = Math.abs(direction[0]) > 30;
      const longVerticalEnough = Math.abs(direction[1]) > 30;
      const horizontalEnough = Math.abs(direction[0]) > Math.abs(direction[1] * 3);
      const verticalEnough = Math.abs(direction[1]) > Math.abs(direction[0] * 3);

      if (fastEnough && longHorizontalEnough && horizontalEnough) { // Horizontal enough
        const swipeHorizontalDir = direction[0] < 0 ? 'next' : 'previous';
        if (swipeHorizontalDir === 'next') {
          this.next.emit();
        } else {
          this.previous.emit();
        }
      } else if (fastEnough && longVerticalEnough && verticalEnough) {
        const swipeVerticalDir = direction[1] < 0 ? 'up' : 'down';
        if (swipeVerticalDir === 'up') {
          this.up.emit();
        } else {
          this.down.emit();
        }
      }
    }
  }
}
